import React from 'react'
import { Pressable } from 'react-native'
import Animated, {
  interpolate,
  useAnimatedStyle,
} from 'react-native-reanimated'
import Icon from '@ui/elements/Icon/Icon'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import { colors } from '@ui/colors'
import cn from '@ui/utils/cn'
import { PressableIconProps } from './types'

export default function PressableIcon({
  className,
  onPress,
  name,
  children,
  color = colors.black,
  size = 32,
  sizeIcon = 24,
  sizeRipple = 48,
  // fill,
  style = {},
  disabled,
  ...rest
}: PressableIconProps) {
  const {
    animation: animationSelf,
    onPressIn: onPressInSelf,
    onPressOut: onPressOutSelf,
  } = useAnimatedPress()

  const animation = rest.animation || animationSelf
  const onPressIn = rest.onPressIn || onPressInSelf
  const onPressOut = rest.onPressOut || onPressOutSelf

  const styleRipple = useAnimatedStyle(() => {
    const opacity = interpolate(animation.value, [0, 1], [0, 0.1], {
      extrapolateRight: 'clamp',
      extrapolateLeft: 'clamp',
    })

    const scale = interpolate(animation.value, [0, 1], [0.5, 1], {
      extrapolateRight: 'clamp',
      extrapolateLeft: 'clamp',
    })

    return {
      opacity,
      transform: [{ scale }],
    }
  })

  return (
    <Pressable
      hitSlop={4}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
      onPress={onPress}
      disabled={!onPress || disabled}
    >
      <Animated.View
        className={cn('items-center justify-center self-center', className)}
        style={[
          style,
          {
            width: size,
            height: size,
          },
        ]}
      >
        {!disabled && (
          <Animated.View
            className="absolute rounded-full"
            style={[
              styleRipple,
              {
                backgroundColor: color,
                width: sizeRipple,
                height: sizeRipple,
                top: -(sizeRipple - size) / 2,
                left: -(sizeRipple - size) / 2,
              },
            ]}
          />
        )}
        {name && (
          <Icon
            name={name}
            size={sizeIcon}
            color={disabled ? colors.neutral[300] : color}
          />
        )}
        {children}
      </Animated.View>
    </Pressable>
  )
}
